import { FC, useState, MouseEvent } from 'react'
import { ResourceImage } from '../Types'

import { useModuleContext } from '../contexts/ModuleContext'
import DraggableDiagram from './DraggableDiagram'

type Props = {
    diagrams: ResourceImage[]
    onDiagramClose: (e: MouseEvent<HTMLElement>, diagram: ResourceImage) => void
}

const ResourcesViewer: FC<Props> = ({ diagrams, onDiagramClose }: Props) => {
    const { user: { electricalCode } } = useModuleContext()
    if (diagrams.length === 0) throw new Error('Visible diagrams cannot be an empty array.')
    const assetsPath = process.env.PUBLIC_URL + '/assets/images/' + electricalCode + '/'
    const [activeDiagram, setActiveDiagram] = useState<ResourceImage | null>(null)

    const draggableDiagrams = diagrams.map((diagram: ResourceImage, idx: number) => {
        const zIndexClass = diagram === activeDiagram ? 'diagram-top-z-index' : ''
        return (
            <DraggableDiagram
                key={'ri' + idx}
                diagram={diagram}
                path={assetsPath}
                index={idx}
                onMouseDown={setActiveDiagram}
                onDiagramClose={onDiagramClose}
                cssClass={zIndexClass}
            />
        )
    })

    return (
        <div className={'interactive'}>
            {draggableDiagrams}
        </div>
    )
}

export default ResourcesViewer